document.addEventListener('DOMContentLoaded', function () {
  const timelineElems = document.querySelectorAll('.adaptation_new_timeline__inner__timeline__elem');
  const timelineLines = document.querySelectorAll('.adaptation_new_timeline__inner__timeline__line');
  const resultItems = document.querySelectorAll('.adaptation_new_timeline__inner__result__item');

  // Set initial state
  let currentSlide = 0;
  let autoplayInterval;
  const slideInterval = 10000; // 10 seconds per slide
  let animationStartTime;
  let animationRequestId;
  let sliderInitialized = false;

  initSliderUI();
  initSwipeHandlers();

  const presentationSection = document.querySelector('.adaptation_new_timeline');
  if (presentationSection) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !sliderInitialized) {
            startAutoplay();
            sliderInitialized = true;
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 },
    );

    observer.observe(presentationSection);
  } else {
    startAutoplay();
    sliderInitialized = true;
  }

  function initSliderUI() {
    resultItems.forEach((item, index) => {
      if (index === 0) {
        item.classList.add('active');
      } else {
        item.classList.remove('active');
      }
    });

    timelineElems[0].classList.add('active');

    timelineLines.forEach((line) => {
      const progressElement = document.createElement('div');
      progressElement.className = 'progress';
      line.appendChild(progressElement);
    });

    timelineElems.forEach((elem, index) => {
      elem.addEventListener('click', () => {
        goToSlide(index);
      });
    });
  }

  function goToSlide(index) {
    if (animationRequestId) {
      cancelAnimationFrame(animationRequestId);
      animationRequestId = null;
    }

    currentSlide = index;

    resultItems.forEach((item, i) => {
      if (i === index) {
        item.classList.add('active');
      } else {
        item.classList.remove('active');
      }
    });

    updateTimelineUI();

    if (sliderInitialized) {
      startAutoplay();
    }
  }

  function updateTimelineUI() {
    timelineElems.forEach((elem, index) => {
      if (index <= currentSlide) {
        elem.classList.add('active');
      } else {
        elem.classList.remove('active');
      }
    });

    timelineLines.forEach((line, index) => {
      const progressElement = line.querySelector('.progress');

      if (index < currentSlide) {
        line.classList.add('completed');
        progressElement.style.width = '100%';
      } else if (index === currentSlide) {
        line.classList.remove('completed');
        progressElement.style.width = '0%';
      } else {
        line.classList.remove('completed');
        progressElement.style.width = '0%';
      }
    });
  }

  function startAutoplay() {
    if (autoplayInterval) {
      clearInterval(autoplayInterval);
    }

    if (currentSlide < timelineLines.length) {
      animateProgress(timelineLines[currentSlide], 0, 100, slideInterval);
    }

    autoplayInterval = setInterval(() => {
      const nextSlide = (currentSlide + 1) % timelineElems.length;
      goToSlide(nextSlide);
    }, slideInterval);
  }

  function animateProgress(lineElement, startPercent, endPercent, duration) {
    const progressElement = lineElement.querySelector('.progress');
    if (!progressElement) return;

    progressElement.style.width = `${startPercent}%`;

    lineElement.offsetWidth;

    animationStartTime = Date.now();

    function step() {
      const currentTime = Date.now();
      const elapsedTime = currentTime - animationStartTime;
      const progress = Math.min(elapsedTime / duration, 1);
      const currentPercent = startPercent + (endPercent - startPercent) * progress;

      progressElement.style.width = `${currentPercent}%`;

      if (progress < 1) {
        animationRequestId = requestAnimationFrame(step);
      }
    }

    animationRequestId = requestAnimationFrame(step);
  }

  function initSwipeHandlers() {
    resultItems.forEach((item) => {
      let touchStartX = 0;
      let touchEndX = 0;

      item.addEventListener(
        'touchstart',
        function (e) {
          touchStartX = e.changedTouches[0].screenX;
        },
        { passive: true },
      );

      item.addEventListener(
        'touchmove',
        function (e) {
          const currentX = e.changedTouches[0].screenX;
          const horizontalDistance = Math.abs(currentX - touchStartX);
          const minDistance = 10;

          if (horizontalDistance > minDistance) {
            e.preventDefault();
          }
        },
        { passive: false },
      );

      item.addEventListener(
        'touchend',
        function (e) {
          touchEndX = e.changedTouches[0].screenX;
          handleSwipe();
        },
        { passive: true },
      );

      function handleSwipe() {
        const swipeDistance = Math.abs(touchEndX - touchStartX);
        const minSwipeDistance = 50;

        if (swipeDistance > minSwipeDistance) {
          if (touchEndX < touchStartX) {
            const nextSlide = (currentSlide + 1) % timelineElems.length;
            goToSlide(nextSlide);
          } else if (touchEndX > touchStartX) {
            const prevSlide = (currentSlide - 1 + timelineElems.length) % timelineElems.length;
            goToSlide(prevSlide);
          }
        }
      }
    });
  }
});
